import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ProductactivationlistComponent } from './productactivationlist/productactivationlist.component';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { ProductactivationlistnewComponent } from './productactivationlistnew/productactivationlistnew.component';
import { DeleteacticationComponent } from './deleteactication/deleteactication.component';

@NgModule({
  declarations: [
    AppComponent,
    ProductactivationlistComponent,
    ProductactivationlistnewComponent,
    DeleteacticationComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    RouterModule,
    HttpClientModule, FormsModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
